<template>
  <lf-card class="min-h-60 flex justify-center items-center">
    {{ $t("WORKFLOW.UNKNOWN_BLOCK") }}
  </lf-card>
</template>
